module.exports = __webpack_public_path__ + "img/avatar.f3f2bdab.png";